import { fetcher } from "helpers/fetcher";

import {
  TSetResidenceWithDefaultAddressReq,
  TSetResidenceWithDefaultAddressRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const setResidenceWithDefaultAddress = async (
  payload: TSetResidenceWithDefaultAddressReq
) => {
  return await fetcher<
    TSetResidenceWithDefaultAddressRes,
    TSetResidenceWithDefaultAddressReq["data"]
  >(ENDPOINT.USER.SET_DEFAULT_AS_RESIDENCE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]: ENDPOINT.USER.SET_DEFAULT_AS_RESIDENCE.version,
    },
  });
};

export const mutationSetResidenceWithDefaultAddress = async (
  payload: TSetResidenceWithDefaultAddressReq
) => {
  return (await setResidenceWithDefaultAddress(payload)).data.message;
};

mutationSetResidenceWithDefaultAddress._key = (
  payload: TSetResidenceWithDefaultAddressReq
) => [ENDPOINT.USER.SET_DEFAULT_AS_RESIDENCE.url, payload];
